import React from "react";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";

const CopyRight = () => {
	return (
		<div style={{ backgroundColor: "rgb(0 0 0 / 5%)", padding: "15px 0 0 0" }}>
			<Divider className='borderColor' />
			<Typography
				variant='body1'
				component='div'
				className='textColor'
				sx={{ py: 1 }}>
				<a
					className='textColor'
					href='https://vcard.freedomvirtualsolutions.com/digitalbusinesscard'
					target='_blank'
					style={{ fontWeight: "bold" }}
					rel='noreferrer'>
					Get Your Own Business App
				</a>
				<br />
				Copyright © 2022 Freedom Virtual Solutions, LLC – All rights reserved.
			</Typography>
		</div>
	);
};

export default CopyRight;
